import React, { useState } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import baseUrl from '../Constant'
import axios from 'axios'
import { useEffect } from 'react'

export default function DashBoard() {
    const [caseCount, setCaseCount] = useState('')
    const [patientCount, setPatientCount] = useState('')

    const dashboardCount = (() => {
        const token = JSON.parse(localStorage.getItem('token'))
        console.log(token)
        axios.get(`${baseUrl}/accounts/dashboard`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setCaseCount(res.data.case_count)
                setPatientCount(res.data.patient_count
                )

            })
            .catch((error) => {
                console.log(error)
            })
    })

    useEffect(() => {
        dashboardCount()
    }, [])


    return (
        <div>
            <Header />
            <div className='d-flex' >
                <div>
                    <Sidebar />
                </div>
                <div className='container-fluid' style={{ backgroundColor: 'rgb(42 127 155 / 24%)', display: 'flex', justifyContent: "center", alignItems: "center" }}>
                    <div style={{ display: "block", width: "100%" }}>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='row' style={{ justifyContent: "space-evenly", }} >
                                    <div className='col-md-4 dashboard  ' >
                                        <div style={{ textAlign: "center", padding: '30px' }}>
                                            <p style={{ color: 'white', fontSize: '18px', fontWeight: "bold" }}>TOTAL PATIENT</p>
                                            <h4 className='text-white '>{patientCount}</h4>
                                        </div>
                                    </div>
                                    <div className='col-md-4 dashboard' >
                                        <div style={{ textAlign: "center", padding: '30px' }}>
                                            <p style={{ color: 'white', fontSize: '18px', fontWeight: "bold" }}>TOTAL CASE</p>
                                            <h4 className='text-white '>{caseCount}</h4>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>

    )
}
